export default __webpack_public_path__ + "static/media/FordBG.ea717fa0.png";